import React from "react";
import { TableCell, TableSortLabel, type SxProps, type Theme } from "@mui/material";

interface SortableTableCellProps<T extends string> {
  label: string;
  field: T;
  sortBy: T;
  sortOrder: "asc" | "desc";
  onSort: (field: T) => void;
  align?: "left" | "right" | "center";
  width?: number | string;
  sx?: SxProps<Theme>;
}

function SortableTableCell<T extends string>({
  label,
  field,
  sortBy,
  sortOrder,
  onSort,
  align,
  width,
  sx,
}: SortableTableCellProps<T>) {
  return (
    <TableCell
      align={align}
      width={width}
      title={label}
      sx={[
        {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: 0,
          "& .MuiTableSortLabel-root": {
            maxWidth: "100%",
            overflow: "hidden",
          },
          "& .MuiTableSortLabel-root .MuiTableSortLabel-icon": {
            flexShrink: 0,
          },
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      sortDirection={sortBy === field ? sortOrder : false}
    >
      <TableSortLabel
        active={sortBy === field}
        direction={sortBy === field ? sortOrder : "asc"}
        onClick={() => onSort(field)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}

export default SortableTableCell;
